export const ProductInitialState = {
  productList: [],
  selectedProduct: null,
  addedProducts: [],
  setCurrentProductToAdd: null,
  selectedProductArray: [],
  selectedVariation: [],
  selectedProductAddCMS: [],
};
